<ion-input class="input" style="border: none;" [hidden]="to.hidden" [(ngModel)]="model[fieldKey]"
	[formControl]="formControl" [ngStyle]="to.uppercase? {'text-transform': 'uppercase'} : {}" type="email"
	inputmode="email" debounce=250 (ionChange)="emailChanged($event)">
</ion-input>